<template>
	<div class="hiq-event-view" :class="isVisitSite ? 'hiq-event-view__visit' : ''">
		<heading v-if="type !== 'page'"/>
		<text-and-image v-if="type !== 'page'"/>
		<share-event/>
		<info/>
	</div>
</template>

<script>
import Vue from 'vue';
import Heading from './components/Heading';
import TextAndImage from './components/TextAndImage';
import Info from './components/Info';
import ShareEvent from './components/ShareEvent';

export default ({
	name: 'app',
	computed: {
		type() { return this.$store.state.type; },
		isVisitSite() { return this.$store.state.isVisitSite; }
	},
	components: {
		Heading,
		TextAndImage,
		Info,
		ShareEvent
	}
})
</script>
